"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = require("./base");
var Image = /** @class */ (function (_super) {
    tslib_1.__extends(Image, _super);
    function Image(cfg) {
        /* istanbul ignore next */
        return _super.call(this, tslib_1.__assign({ type: 'image', start: null, end: null, src: '' }, cfg)) || this;
    }
    Image.prototype.render = function (coord, group) {
        var start = this.parsePoint(coord, this.get('start'));
        var cfg = {
            x: start.x,
            y: start.y,
            img: this.get('src'),
        };
        if (!this.get('end')) {
            cfg.width = this.get('width') || 32;
            cfg.height = this.get('height') || 32;
        }
        else {
            var end = this.parsePoint(coord, this.get('end'));
            cfg.width = end.x - start.x;
            cfg.height = end.y - start.y;
        }
        if (this.get('offsetX')) {
            cfg.x += this.get('offsetX');
        }
        if (this.get('offsetY')) {
            cfg.y += this.get('offsetY');
        }
        var imgGuide = group.addShape('Image', {
            zIndex: 1,
            attrs: cfg,
        });
        imgGuide.name = 'annotation-image';
        this.get('appendInfo') &&
            imgGuide.setSilent('appendInfo', this.get('appendInfo'));
        this.set('el', imgGuide);
    };
    return Image;
}(base_1.default));
exports.default = Image;
//# sourceMappingURL=image.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/component/lib/annotation/image.js
// module id = 762
// module chunks = 37